import React, { ReactElement } from 'react';
import {
  Col,
  Heading,
  HeadingCaption,
  Row,
  SecondaryNavigation,
  SecondaryNavigationItem,
  Text,
} from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../../../../routing/routes';
import ActionButton from '../../../../module/ActionButton/ActionButton';
import { useUserContext } from '../../../../context/UserContext';
import mapDate from '../../../../function/mapDate';
import Uuid from '../../../../model/Uuid';
import VzneseneInMpkLink from '../VzneseneInMpkLink/VzneseneInMpkLink';
import VlastnyMaterialButton from '../VlastnyMaterialButton/VlastnyMaterialButton';
import './pripomienkyNavigation.scss';

interface Props {
  reloadSubjektBezPripomienokList?(): void;
  assignedList?: Array<Uuid>;
  setAssignedList?: (assignedList: Array<Uuid>) => void;
  reloadPripomienkyList?(): void;
  reloadFilterData?(): void;
}

const PripomienkyNavigation = ({
  reloadSubjektBezPripomienokList,
  assignedList,
  setAssignedList,
  reloadPripomienkyList,
  reloadFilterData,
}: Props): ReactElement => {
  const {
    pouzivatel,
    legislationProcess,
  } = useUserContext();
  const location = useLocation();

  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  const userIsLogged = (): boolean => (pouzivatel != null);

  const showActionButton = (): boolean => userIsLogged();

  return (
    <>
      {type && year && index && legislationProcess && (
        <div className="sprava-pripomienok-navigation">
          <Row>
            <Col width="two-thirds" className="first-col">
              <div className="sprava-pripomienok-navigation__first-col-wrapper">
                <div>
                  <HeadingCaption>
                    {`Legislatívny proces ${type}/${year}/${index}`}
                  </HeadingCaption>
                  <Heading size="xl">Pripomienky</Heading>
                </div>
                {showActionButton() && (
                  <ActionButton
                    assignedList={assignedList}
                    setAssignedList={setAssignedList}
                    reloadPripomienkyList={reloadPripomienkyList}
                    reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
                    reloadFilterData={reloadFilterData}
                  />
                )}
              </div>
            </Col>
            <Col width="one-third" className="second-col">
              <div className="pripomienky-navigation__info-wrapper">
                <Text size="s" type="span">Aktuálne štádium materiálu</Text>
                {legislationProcess?.stadiumProcesu && (
                  <Text size="m" type="span">
                    <b>{legislationProcess.stadiumProcesuValue}</b>
                  </Text>
                )}
              </div>
              <div className="pripomienky-navigation__info-wrapper">
                <Text size="s" type="span">Dátum ukončenia PK</Text>
                {legislationProcess?.datumKoncaMpk && (
                  <Text size="m" type="span"><b>{mapDate(legislationProcess.datumKoncaMpk)}</b></Text>
                )}
              </div>
              <VlastnyMaterialButton
                uuid={legislationProcess?.legMaterialUuid}
                actualStadium={legislationProcess.stadiumProcesu}
              />
              <VzneseneInMpkLink legislationProcess={legislationProcess} />
            </Col>
          </Row>
          <SecondaryNavigation className="sprava-pripomienok-navigation__secondary">
            <SecondaryNavigationItem
              active={location.pathname.startsWith(routes.pripomienky.index(type, year, index))}
              to={routes.pripomienky.list.withParams(type, year, index)}
            >
              Pripomienky
            </SecondaryNavigationItem>
            <SecondaryNavigationItem
              active={location.pathname.startsWith(routes.hromadnePripomienky.index(type, year, index))}
              to={routes.hromadnePripomienky.list.withParams(type, year, index)}
            >
              Hromadné pripomienky
            </SecondaryNavigationItem>
          </SecondaryNavigation>
        </div>
      )}
    </>
  );
};

export default PripomienkyNavigation;
